import Vuex from "vuex";
import Vue from 'vue';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
Vue.use(Vuex);
export function createStore() {
    return new Vuex.Store({
        state: {
            posts: [],
            categories: [],
            currentPost: null,
            currentCategory: null
        },
        getters,
        mutations,
        actions
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = null
// module chunks = 